import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/means-test']['GET'];
type Input = ThisApi['query'];

/**
 * Fetches the means test data for a document request user.
 * Returns deterministically calculated means test values.
 */
const getMeansTestData = async ({ documentRequestUserId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get<ThisApi['response']>('/document-request-users/means-test', {
    params: { documentRequestUserId },
  });
  return response.data;
};

export default getMeansTestData;
